import React from "react";
import {
    Typography,
    TextField,
    Button,
} from "@mui/material";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import API from "../../../api";
import { ReactNotifications } from "react-notifications-component";
import { startToast, updateToastError, updateToastWarning, updateToastSuccess } from "../../../utils/notification-loading";

const StyledText = styled(TextField)`
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #52a0a6; // Cambia con il tuo colore di focus desiderato
  }
  & .MuiInputLabel-outlined.Mui-focused {
    color: #52a0a6; // Cambia con il tuo colore di focus desiderato
  }
`;


const AddLecs = () => {
  startToast();
    const [mac, setMac] = useState()
    const [error, setError] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();

        API.postAddIcosLecs({
            "mac": mac
        }).then(response => {
        
            updateToastSuccess("Lecs successfully entered");
            window.location.reload()
        }).catch(error => {
            console.error('[handleSubmit] error:', error);
            if (error.response.status === 409) {
              updateToastWarning("Lecs already produced");
            }
            else{
              updateToastError("Error During Insertion");
            }
        })
    }

    const validateMacAddress = (macAddress) => {
        const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
        if (!macRegex.test(macAddress) && macAddress !== "") {
          return "Invalid MAC Address format. EXAMPLE: ff:ff:ff:ff:ff:ff";
        }
        return "";
      };

    const handleMacChange = (e) => {
        const newMac = e.target.value;
        setMac(newMac)
        const errorMac = validateMacAddress(newMac);
        setError(errorMac)
    }



    return (
        <>
            <ReactNotifications />
            <Typography sx={{fontSize: 18, fontWeight: 600}}>Produce LECS</Typography>
            <StyledText
                label="Insert the MAC-ADDRESS"
                variant="outlined"
                fullWidth
                required
                onChange={handleMacChange}
                error={!!error}
                helperText={error}

            />
            <Button
                fullWidth
                type="submit"
                variant="contained"
                onClick={handleSubmit}
                disabled={error || mac === ''}
                sx={{
                    backgroundColor: "#2d2d2d !important",
                    fontWeight: 900,
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
            >
                REGISTER
            </Button>
        </>
    )
}

export default AddLecs